import { ArrowLeft, ArrowRight } from "lucide-react";

export default function ProjectNav({ prev, next }) {
  return (
    <div className="flex justify-between items-center pt-16 pb-4 text-lg opacity-80">
      
      {prev ? (
        <a href={prev.href} className="flex items-center gap-2 hover:opacity-100 transition">
          <ArrowLeft size={18} /> {prev.label}
        </a>
      ) : <div />}

      {next ? (
        <a href={next.href} className="flex items-center gap-2 hover:opacity-100 transition">
          {next.label} <ArrowRight size={18} />
        </a>
      ) : <div />}
    </div>
  );
}
